module.exports = __webpack_public_path__ + "img/aerion.54299e8b.png";